import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { CatalogoService } from '../../../../service/CatalogoService';
import * as generic from '../../../../components/Generico';
import { InformacionGeneral } from '../../../../models/trust/empleado/InformacionGeneral';
import { EmpleadoAcDirService } from '../../../../service/trust/empleado/EmpleadoAcDirService';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';
import { InputActividadEconomica } from '../../../../components/ui/Formularios/InputActividadEconomica';

export const InfoGeneral = ({ toast, id, empleado, permss, catalogos, handleNext, nuevoEmpleado, soloLectura }) => {

    const omodel = new InformacionGeneral();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, getValues, trigger, clearErrors } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const empleadoServicio = new EmpleadoAcDirService();
    const catalogoService = new CatalogoService();
    const { inDrop, inText, inCalendar, inArea, inDropMultiple } = InputComponent({ omodel, errors, control, permss, id, soloLectura });

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    // Sección 1 — país de la declaración
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    // Sección 3 — país de residencia
    const [ecuadorResidencia, setEcuadorResidencia] = useState(false);
    const [ciudadesResidencia, setCiudadesResidencia] = useState([]);
    // Identificación declarante
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    // Identificación cónyuge
    const [esRucCy, setEsRucCy] = useState(false);
    const [esCedulaCy, setEsCedulaCy] = useState(false);
    // Estado civil
    const [esCasado, setEsCasado] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.ec = catalogos?.ecuador;
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_nacimiento = generic.dateToString(data.fecha_nacimiento);
        data.casado = catalogos?.casado;
        data.union = catalogos?.union;
        data.seccion = 'seccion1';

        if (id == null) {
            empleadoServicio.nuevo(data).then(res => {
                nuevoEmpleado(res.data);
                generic.funcSuccess(res, toast);
                handleNext();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => setIsSaving(false));
        } else {
            data.id = id;
            empleadoServicio.editar(data).then(res => {
                nuevoEmpleado(res.data);
                generic.funcSuccess(res, toast);
                handleNext();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => setIsSaving(false));
        }
    }

    const editFicha = () => {
        setIsLoading(true);
        empleadoServicio.consultar(id ?? 0, { seccion: 'seccion1' }).then(res => {
            const cats = catalogos;
            const _emp = res.data.empleado;

            if (!_emp) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            // Estado civil
            setEsCasado(
                JSON.stringify(_emp.estado_civil) === JSON.stringify(cats?.casado) ||
                JSON.stringify(_emp.estado_civil) === JSON.stringify(cats?.union)
            );

            // Sección 1 — país de la declaración (campo: pais)
            setEcuador(_emp.pais?.cat_id === cats?.ecuador?.cat_id);
            if (res.data.ciudades) setCiudades(res.data.ciudades);

            // Sección 3 — país de residencia (campo: pais_residencia)
            setEcuadorResidencia(_emp.pais_residencia?.cat_id === cats?.ecuador?.cat_id);
            if (res.data.ciudades_residencia) setCiudadesResidencia(res.data.ciudades_residencia);

            // Identificación declarante
            setEsRuc(_emp.tipo_identificacion?.cat_id === cats?.ruc?.cat_id);
            setEsCedula(_emp.tipo_identificacion?.cat_id === cats?.cedula?.cat_id);

            // Identificación cónyuge
            setEsRucCy(_emp.tipo_identificacion_cy?.cat_id === cats?.ruc?.cat_id);
            setEsCedulaCy(_emp.tipo_identificacion_cy?.cat_id === cats?.cedula?.cat_id);

            _emp.fecha = generic.stringToDate(_emp.fecha);
            _emp.fecha_nacimiento = generic.stringToDate(_emp.fecha_nacimiento);

            nuevoEmpleado({ id: _emp.id, nemonico: _emp.nemonico });
            reset(generic.renewValues(_emp, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    // opcion=true → sección 1 (pais/provincia/ciudad); opcion=false → sección 3 (pais_residencia/...)
    const onChangePais = (e, opcion) => {
        if (opcion) {
            setEcuador(e.value?.cat_id === catalogos?.ecuador?.cat_id);
            setValue('provincia', null);
            setValue('ciudad', null);
            setCiudades([]);
        } else {
            setEcuadorResidencia(e.value?.cat_id === catalogos?.ecuador?.cat_id);
            setValue('provincia_residencia', null);
            setValue('ciudad_residencia', null);
            setCiudadesResidencia([]);
            if (getValues('telefono')) {
                trigger('telefono');
            }
            if (getValues('celular')) {
                trigger('celular');
            }
        }
    }

    const onChangeProvincia = (e, opcion) => {
        if (opcion) {
            setValue('ciudad', null);
            if (!e?.value) { setCiudades([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
        } else {
            setValue('ciudad_residencia', null);
            if (!e?.value) { setCiudadesResidencia([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesResidencia(res.data));
        }
    }

    const onChangeTipo = (e) => {
        setEsRuc(JSON.stringify(e.value) === JSON.stringify(catalogos?.ruc));
        setEsCedula(JSON.stringify(e.value) === JSON.stringify(catalogos?.cedula));
        clearErrors('identificacion');
    }

    const onChangeTipoCy = (e) => {
        setEsRucCy(JSON.stringify(e.value) === JSON.stringify(catalogos?.ruc));
        setEsCedulaCy(JSON.stringify(e.value) === JSON.stringify(catalogos?.cedula));
        clearErrors('identificacion_cy');
    }

    const onChangeEstadoCivil = (e) => {
        setEsCasado(
            JSON.stringify(e.value) === JSON.stringify(catalogos?.casado) ||
            JSON.stringify(e.value) === JSON.stringify(catalogos?.union)
        );
    }

    const tipoDoc = esRuc ? 'IDEN_RUC' : esCedula ? 'IDEN_CEDULA' : null;
    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `${esRuc ? 'RUC' : 'Cédula'} incorrecto`;
    };

    const tipoDocCy = esRucCy ? 'IDEN_RUC' : esCedulaCy ? 'IDEN_CEDULA' : null;
    const reglaValidacionCy = (val) => {
        if (!tipoDocCy) return true;
        return generic.validarIdentificacionEcuador(val, tipoDocCy) || `${esRucCy ? 'RUC' : 'Cédula'} incorrecto`;
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('1', 'IDENTIFICACIÓN DE LA DECLARACIÓN', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inCalendar('fecha', {}, 4)}
                    {inDropMultiple('tipo_declarante', catalogos?.tipo_declarante, { lab: omodel.optionLabel }, 4)}
                    {inDrop('tipo_declaracion', catalogos?.tipo_declaracion, { lab: omodel.optionLabel }, 4)}
                    {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: true }, 4)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: true }, 4)}
                            {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton', { icon: 'pi pi-map-marker' }, 8)
                    )}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('2', 'IDENTIFICACIÓN DEL DECLARANTE', 'pi pi-user')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, 3)}
                    {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 3)}
                    {inText('nombre_completo', { icon: 'pi pi-user' }, 6)}
                    {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 4)}
                    {inCalendar('fecha_nacimiento', {}, 4)}
                    {inDrop('estado_civil', catalogos?.estado_civil, { lab: omodel.optionLabel, chn: onChangeEstadoCivil }, 4)}
                    {inText('hijo_edad', { icon: 'pi pi-users' }, 12)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('3', 'DATOS DEL DOMICILIO DEL DECLARANTE', 'pi pi-home')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDrop('pais_residencia', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, 4)}
                    {ecuadorResidencia ? (
                        <>
                            {inDrop('provincia_residencia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 4)}
                            {inDrop('ciudad_residencia', ciudadesResidencia, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_residencia', { icon: 'pi pi-map-marker' }, 8)
                    )}

                    {inArea('direccion_domicilio', 3, 200, 12)}
                    {inDrop('tipo_vivienda', catalogos?.tipo_vivienda, { lab: omodel.optionLabel }, 4)}
                    {inText('telefono', { icon: 'pi pi-phone', validate: generic.validarTelefonoDinamico(getValues, 'pais_residencia') }, 4)}
                    {inText('celular', { icon: 'pi pi-mobile', validate: generic.validarTelefonoDinamico(getValues, 'pais_residencia') }, 4)}
                    {inText('email', { icon: 'pi pi-envelope', pattern: generic.VALIDACION_EMAIL }, 12)}
                </div>
            </Panel>

            {esCasado && (
                <Panel header={generic.renderPanelHeader('4', 'IDENTIFICACIÓN DEL CÓNYUGE O CONVIVIENTE', 'pi pi-heart')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        {inDrop('tipo_identificacion_cy', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipoCy }, 3)}
                        {inText('identificacion_cy', { validate: reglaValidacionCy, icon: 'pi pi-id-card' }, 3)}
                        {inText('nombre_completo_cy', { icon: 'pi pi-user' }, 6)}
                        <InputActividadEconomica name="actividad_economica_cy" control={control} modelDef={omodel.model['actividad_economica_cy']} disabled={soloLectura} col={12} />
                        {inText('cargo_lugar_trabajo_cy', { icon: 'pi pi-briefcase' }, 12)}
                        {inDrop('separacion_bienes', generic.estadosSiNo, { lab: 'nombre', val: true }, 6)}
                        {inDrop('liquidacion_sociedad_conyugal', generic.estadosSiNo, { lab: 'nombre', val: true }, 6)}
                    </div>
                </Panel>
            )}
            <BottomActionBar layoutVersion="v2" onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
